import { render, staticRenderFns } from "./ModalCloseButtonNew.vue?vue&type=template&id=72173448&"
import script from "./ModalCloseButtonNew.vue?vue&type=script&lang=js&"
export * from "./ModalCloseButtonNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports